/* eslint-disable react/no-unstable-nested-components */
import React from "react";
import { FaAngleDown, FaAngleRight } from "react-icons/fa";
import DataTable from "react-data-table-component";
import DebitoSuspensoDetalhe from "./DebitoSuspensoDetalhe";

const DebitoSuspensoCard = ({ debitoSuspenso }) => {
  const columns = [
    {
      name: "Data Vencimento",
      selector: "dataVencimentoDebito",
      center: true,
    },
    {
      name: "Origem Débito",
      selector: "origemDebito",
      center: true,
    },
    {
      name: "Valor Nominal",
      cell: (row) => row.valor.toLocaleString("pt-br", { minimumFractionDigits: 2 }),
      sortable: true,
      center: true,
    },
    {
      width: "55px",
      selector: (row) => (row.expanded ? <FaAngleDown /> : <FaAngleRight />),
    },
  ];

  return (
    <div className="col-lg-12">
      <div className="card shadow mb-1">
        <div className="card-header">
          <b>{debitoSuspenso?.titulo}</b>
        </div>
        <div className="card-body">
          <center>
            <DataTable
              columns={columns}
              data={debitoSuspenso?.itensDebitosSuspensosPorSituacao}
              expandableRowsHideExpander
              expandOnRowClicked
              expandableRows
              expandableRowsComponent={DebitoSuspensoDetalhe}
            />
            <b>
              Total Geral dos {debitoSuspenso.titulo} R${" "}
              {debitoSuspenso.valorTotal.toLocaleString("pt-br", { minimumFractionDigits: 2 })}
            </b>
          </center>
        </div>
      </div>
    </div>
  );
};

export default DebitoSuspensoCard;
